The reason why a specific position was not posted on SEEK, identified by its reason ID.
